export default __webpack_public_path__ + "static/media/profile-flash.d9c0fe2d.png";